import { render, staticRenderFns } from "./MetadadosCampoDinamicoDinheiro.vue?vue&type=template&id=e216374a"
import script from "./MetadadosCampoDinamicoDinheiro.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoDinheiro.vue?vue&type=script&lang=js"
import style0 from "./MetadadosCampoDinamicoDinheiro.vue?vue&type=style&index=0&id=e216374a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports